/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Scanning_ToastInputs */

const en_scene_change_detection_scanning_toast = /** @type {(inputs: Scene_Change_Detection_Scanning_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanning media for shot changes`)
};

const fr_scene_change_detection_scanning_toast = /** @type {(inputs: Scene_Change_Detection_Scanning_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse du media pour les changements de plan`)
};

const de_scene_change_detection_scanning_toast = /** @type {(inputs: Scene_Change_Detection_Scanning_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien nach Szenenwechseln durchsuchen`)
};

const it_scene_change_detection_scanning_toast = /** @type {(inputs: Scene_Change_Detection_Scanning_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scansione dei supporti per modifiche di ripresa`)
};

const ru_scene_change_detection_scanning_toast = /** @type {(inputs: Scene_Change_Detection_Scanning_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сканирование медиафайлов для смены кадров.`)
};

const es_scene_change_detection_scanning_toast = /** @type {(inputs: Scene_Change_Detection_Scanning_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escaneo de medios para cambios de toma`)
};

const zh_cn2_scene_change_detection_scanning_toast = /** @type {(inputs: Scene_Change_Detection_Scanning_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扫描介质以进行镜头切换`)
};

const ja_scene_change_detection_scanning_toast = /** @type {(inputs: Scene_Change_Detection_Scanning_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットの変更点をメディアでスキャンする`)
};

const hi_scene_change_detection_scanning_toast = /** @type {(inputs: Scene_Change_Detection_Scanning_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट में बदलाव के लिए मीडिया को स्कैन करना`)
};

const pt_pt2_scene_change_detection_scanning_toast = /** @type {(inputs: Scene_Change_Detection_Scanning_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisando a mídia em busca de alterações de planos`)
};

/**
* | output |
* | --- |
* | "Scanning media for shot changes" |
*
* @param {Scene_Change_Detection_Scanning_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_scanning_toast = /** @type {((inputs?: Scene_Change_Detection_Scanning_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Scanning_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_scanning_toast(inputs)
	if (locale === "de") return de_scene_change_detection_scanning_toast(inputs)
	if (locale === "it") return it_scene_change_detection_scanning_toast(inputs)
	if (locale === "ru") return ru_scene_change_detection_scanning_toast(inputs)
	if (locale === "es") return es_scene_change_detection_scanning_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_scanning_toast(inputs)
	if (locale === "ja") return ja_scene_change_detection_scanning_toast(inputs)
	if (locale === "hi") return hi_scene_change_detection_scanning_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_scanning_toast(inputs)
	return en_scene_change_detection_scanning_toast(inputs)
});